import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-overlay',
  standalone: true,
  imports: [],
  templateUrl: './overlay.component.html',
  host: {
    class: 'overlay static'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent {

}
